import moment from "moment";

export const formatMoney = (amount, currency = "ARS", locale) => {
  const value = Number(amount);
  if (Number.isNaN(value)) return "—";
  const loc = locale ? locale.replace("_", "-") : undefined;
  const cur = currency || "ARS";
  try {
    return new Intl.NumberFormat(loc, {
      style: "currency",
      currency: cur,
      currencyDisplay: "narrowSymbol",
      maximumFractionDigits: 2,
    }).format(value);
  } catch (e) {
    try {
      return new Intl.NumberFormat(loc, {
        style: "currency",
        currency: cur,
        maximumFractionDigits: 2,
      }).format(value);
    } catch (e2) {
      return `${cur} ${value.toFixed(2)}`.trim();
    }
  }
};

export const getStatusInfo = (c, t) => {
  if (!c) return { label: "", tone: "" };
  const cds = c.contents_displays || [];
  const isPaused = cds.length > 0 && cds.every((d) => d.active === 0);
  if (isPaused) return { label: t("paused_status"), tone: "paused" };
  if (c.payment_status === "pre_approved")
    return { label: t("Pre approved"), tone: "pending" };
  if (c.total_price_with_profit === 0)
    return { label: t("Subsidized"), tone: "active" };
  if (
    c.status === "ready" ||
    c.contents_displays_approved === c.contents_displays_total
  ) {
    if (moment().isBetween(c.start_date, c.end_date))
      return { label: t("Active"), tone: "active" };
    if (moment(c.start_date).isAfter(moment()))
      return { label: t("Coming soon"), tone: "next" };
    return { label: t("Finalized"), tone: "previous" };
  }
  if (c.status === "cancelled_by_user")
    return { label: t("Cancelled by user"), tone: "cancelled" };
  if (c.status === "cancelled")
    return { label: t("Cancelled"), tone: "cancelled" };
  if (c.status === "proposal") return { label: t("Proposal"), tone: "proposal" };
  if (c.status === "pending") {
    if (c.payment_status === "pre_approved")
      return { label: t("Approved"), tone: "active" };
    return { label: t("Pending"), tone: "pending" };
  }
  return { label: "", tone: "" };
};

export const isInForce = (c) =>
  !!(c && c.end_date && moment().isSameOrBefore(moment(c.end_date)));

export const getDurationDays = (c) => {
  if (!c || !c.start_date || !c.end_date) return 0;
  const days = -moment(c.start_date).diff(moment(c.end_date), "days") + 1;
  return days > 0 ? days : 0;
};

export const getPurchasedSpots = (c) => {
  if (!c || !c.contents_displays) return 0;
  const perDisplay = {};
  c.contents_displays.forEach((d) => {
    const ps = d.promised_shows || 0;
    if (perDisplay[d.display_id] == null || ps > perDisplay[d.display_id]) {
      perDisplay[d.display_id] = ps;
    }
  });
  return Object.values(perDisplay).reduce((a, ps) => a + ps, 0);
};

export const getScreenCount = (c) => {
  if (!c || !c.contents_displays) return 0;
  const ids = new Set();
  c.contents_displays.forEach((d) => ids.add(d.display_id));
  return ids.size;
};

export const getAmounts = (c) => {
  if (!c) return { subtotal: 0, total: 0, currency: "ARS" };
  const subtotal = Number(c.total_price_with_profit) || 0;
  let tax = 0;
  if (c.tax_info && typeof c.tax_info === "object") {
    Object.keys(c.tax_info).forEach((k) => {
      tax += Number(c.tax_info[k] && c.tax_info[k].tax_amount) || 0;
    });
  }
  return { subtotal, total: subtotal + tax, currency: c.currency || "ARS" };
};

export const getCreatorName = (c) => {
  if (!c || !c.creator) return "—";
  const cr = c.creator;
  const fullName = `${cr.first_name || ""} ${cr.last_name || ""}`.trim();
  return fullName || cr.username || cr.email || "—";
};

export const getCountry = (c) =>
  (c && c.invoice_issuing && c.invoice_issuing.name) || "—";

export const getDspName = (c) =>
  (c && c.external_dsp && c.external_dsp.name) || "Latinad";
